/**
 * CardTagsSection — seção "Tags" no detalhe do card (FEAT-V2-031).
 *
 * Reusável em DealDetailDialog (deal), ServiceOrderDetail (service_order),
 * e futuro TaskDetail (task). Combina TagPicker (admin+user adicionam/removem)
 * + admin pode quick-add tag direto no card.
 */

import { useMemo } from 'react';

import { TagPicker } from '@/components/tags';
import { useCardTags, type CardType } from '@/lib/tags-store';
import { useAuth } from '@/contexts/AuthContext';

interface CardTagsSectionProps {
  cardId: string;
  cardType: CardType;
  /** Slug do workflow do card — filtra catálogo a tags permitidas. */
  workflowSlug?: string | null;
}

export function CardTagsSection({
  cardId,
  cardType,
  workflowSlug = null,
}: CardTagsSectionProps) {
  const { user } = useAuth();
  const { data: tags = [] } = useCardTags(cardType, cardId);
  const canQuickAdd = !!user?.isAdmin;

  const sorted = useMemo(
    () => [...tags].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR')),
    [tags],
  );

  return (
    <div data-testid="card-tags-section">
      <p className="eyebrow mb-1">Tags</p>
      <TagPicker
        cardType={cardType}
        cardId={cardId}
        currentTags={sorted}
        workflowSlug={workflowSlug}
        canQuickAdd={canQuickAdd}
      />
    </div>
  );
}
